import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, Clock, Calendar as CalendarIcon, User, CheckCircle2, ShieldCheck, ArrowRight, Star, MapPin, Facebook, Mail, MessageSquare } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const doctors = [{
  id: 'dr-simba',
  name: 'Dr. Simba Pari',
  specialty: 'Lead Clinical Practitioner',
  avatar: 'D'
}, {
  id: 'dr-simons',
  name: 'Dr. Simons',
  specialty: 'Orthodontic & Cosmetic Specialist',
  avatar: 'S'
}];
const services = [{
  id: 'braces',
  name: 'Braces - Frenos',
  duration: '30 mins',
  description: 'Improve your smile and love the way you smile. / Mejora tu sonrisa y ama tu forma de sonreír.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/tbWnDwzMDGimyQqQfWXAZ4/ChatGPT_Image_Jun_23,_2026,_03_17_18_PM.png'
}, {
  id: 'veneers',
  name: 'Veneers - Carillas',
  duration: '30 mins',
  description: 'Change your smile with veneers, book your appointment today! / Cambia tu sonrisa con carillas, ¡reserva tu cita hoy!',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/2WrtrhKG49ofwBxisGsbxx/pasted-image.jpg'
}, {
  id: 'crowns',
  name: 'Crowns and Bridges - Coronas y Puentes Dentales',
  duration: '30 mins',
  description: 'Crowns and bridges can easily replace missing teeth. Get both a new smile and also the ability to eat and chew properly. / Las coronas y los puentes pueden reemplazar fácilmente los dientes faltantes.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/hUFZT6913ZakNRpPwfL21M/Gemini_Generated_Image_9ydslw9ydslw9yds.png'
}, {
  id: 'cleaning',
  name: 'Exam Cleaning Xrays',
  duration: '30 mins',
  description: 'Dental cleaning x-rays and comprehensive exam.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/atYr4HzQUVyvmeLs4ffva8/ChatGPT_Image_Jun_23,_2026,_03_07_45_PM.png'
}, {
  id: 'extraction',
  name: 'Extraction - Extraccion',
  duration: '30 mins',
  description: 'Extraction. / Extraccion.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/efNasSzDNXD9T51LANTFFr/Gemini_Generated_Image_njoi0xnjoi0xnjoi.png'
}, {
  id: 'whitening',
  name: 'Teeth Whitening',
  duration: '30 mins',
  description: 'Brighten your smile with our 1 hour whitening. / Ilumina tu sonrisa con nuestro blanqueamiento de 1 hora.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/2WswGMn6MLeSktEQXy5nFh/ChatGPT_Image_Jun_23,_2026,_03_09_22_PM.png'
}, {
  id: 'implants',
  name: 'Dental Implants - Implante',
  duration: '30 mins',
  description: 'Dental Implants replace your missing teeth.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/eFYruGFgromJp8XFhqyton/ChatGPT_Image_Jun_23,_2026,_03_11_52_PM.png'
}, {
  id: 'invisalign',
  name: 'Invisalign',
  duration: '30 mins',
  description: "Don't want wires in your mouth? No problem, straighten your teeth and perfect your smile with clear aligners.",
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/m6pW2VBERSLr62bh5W2BXa/Gemini_Generated_Image_j5xp9ej5xp9ej5xp.png'
}, {
  id: 'dentures',
  name: 'Dentures - Dentadura',
  duration: '1 hr',
  description: 'Dentures are a perfect economic way to recreate your brilliant smile with teeth that you can use for chewing and eating.',
  price: 'Free Consultation',
  img: 'https://cdn.magicpatterns.com/uploads/19UejF4E7FxZpQmwbETozq/ChatGPT_Image_Jun_23,_2026,_03_15_49_PM.png'
}];
const timeSlots = ['9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '7:00 PM', '7:30 PM'];
export function BookingPage() {
  const [step, setStep] = useState(1);
  const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
  const [selectedService, setSelectedService] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<string>('2026-06-23');
  const [selectedTime, setSelectedTime] = useState<string>('');
  const nextStep = () => setStep(s => s + 1);
  const prevStep = () => setStep(s => s - 1);
  const renderStep = () => {
    switch (step) {
      case 1:
        return <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="space-y-8" data-id="element-452">
            <div className="text-center space-y-4" data-id="element-453">
              <h2 className="text-3xl font-bold text-[#225274]" data-id="element-454">
                Select Your Doctor
              </h2>
              <p className="text-slate-500" data-id="element-455">
                Choose the doctor you'd like to see
              </p>
            </div>
            <div className="max-w-2xl mx-auto space-y-4" data-id="element-456">
              {doctors.map(doctor => <button key={doctor.id} onClick={() => {
              setSelectedDoctor(doctor);
              nextStep();
            }} className="w-full flex items-center justify-between p-6 rounded-2xl border-2 border-slate-100 hover:border-[#54c595] hover:bg-[#cef4d2]/20 transition-all group" data-id="element-457">
                  <div className="flex items-center gap-4" data-id="element-458">
                    <div className="w-16 h-16 bg-slate-200 rounded-full flex items-center justify-center text-2xl font-bold text-slate-600" data-id="element-459">
                      {doctor.avatar}
                    </div>
                    <div className="text-left" data-id="element-460">
                      <h3 className="font-bold text-[#225274] text-lg" data-id="element-461">
                        {doctor.name}
                      </h3>
                      <p className="text-sm text-slate-500" data-id="element-462">
                        {doctor.specialty}
                      </p>
                    </div>
                  </div>
                  <ArrowRight size={20} className="text-slate-400 group-hover:text-[#54c595] transition-colors" data-id="element-463" />
                </button>)}
            </div>
          </motion.div>;
      case 2:
        return <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="space-y-8" data-id="element-464">
            <button onClick={prevStep} className="flex items-center gap-2 text-sm font-bold text-[#4F709C] hover:text-[#225274] transition-colors" data-id="element-465">
              <ChevronLeft size={16} data-id="element-466" /> Back to Doctor Selection
            </button>
            <div className="text-center space-y-4" data-id="element-467">
              <h2 className="text-3xl font-bold text-[#225274]" data-id="element-468">
                Select a Service
              </h2>
              <p className="text-slate-500" data-id="element-469">
                Choose the dental service you'd like to book with{' '}
                {selectedDoctor?.name}
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-470">
              {services.map(service => <button key={service.id} onClick={() => {
              setSelectedService(service);
              nextStep();
            }} className="text-left bg-white rounded-3xl border-2 border-slate-100 hover:border-[#54c595] hover:shadow-xl hover:shadow-[#54c595]/10 transition-all group overflow-hidden flex flex-col sm:flex-row" data-id="element-471">
                  <div className="w-full sm:w-40 h-40 flex-shrink-0 overflow-hidden" data-id="element-472">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-473" />
                  </div>
                  <div className="p-6 flex-1 flex flex-col justify-between" data-id="element-474">
                    <div data-id="element-475">
                      <div className="flex justify-between items-start mb-2 gap-2" data-id="element-476">
                        <h3 className="font-bold text-[#225274] leading-tight" data-id="element-477">
                          {service.name}
                        </h3>
                        <span className="text-[10px] font-bold text-[#54c595] bg-[#cef4d2]/50 px-2 py-0.5 rounded-full uppercase tracking-widest whitespace-nowrap" data-id="element-478">
                          {service.price}
                        </span>
                      </div>
                      <p className="text-xs text-slate-500 mb-4 line-clamp-2 leading-relaxed" data-id="element-479">
                        {service.description}
                      </p>
                    </div>
                    <div className="flex items-center gap-2 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-480">
                      <Clock size={14} className="text-[#54c595]" data-id="element-481" />
                      {service.duration}
                    </div>
                  </div>
                </button>)}
            </div>
          </motion.div>;
      case 3:
        return <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="space-y-8" data-id="element-482">
            <button onClick={prevStep} className="flex items-center gap-2 text-sm font-bold text-[#4F709C] hover:text-[#225274] transition-colors" data-id="element-483">
              <ChevronLeft size={16} data-id="element-484" /> Back to Services
            </button>
            <div className="text-center space-y-4" data-id="element-485">
              <h2 className="text-3xl font-bold text-[#225274]" data-id="element-486">
                Select Date & Time
              </h2>
              <p className="text-slate-500" data-id="element-487">With {selectedDoctor?.name}</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12" data-id="element-488">
              <div className="bg-white p-6 rounded-3xl border border-slate-100 shadow-sm" data-id="element-489">
                <h3 className="font-bold text-[#225274] mb-6 flex items-center gap-2" data-id="element-490">
                  <CalendarIcon size={20} className="text-[#54c595]" data-id="element-491" />
                  Select Date
                </h3>
                <div className="grid grid-cols-7 gap-2 text-center" data-id="element-492">
                  {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(d => <div key={d} className="text-[10px] font-bold text-slate-400 uppercase py-2" data-id="element-493">
                      {d}
                    </div>)}
                  {Array.from({
                  length: 30
                }).map((_, i) => <button key={i} disabled={i < 22} className={`h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold transition-all ${i === 22 ? 'bg-[#225274] text-white shadow-lg' : i < 22 ? 'text-slate-200 cursor-not-allowed' : 'text-slate-600 hover:bg-[#cef4d2]/50 hover:text-[#54c595]'}`} data-id="element-494">
                      {i + 1}
                    </button>)}
                </div>
              </div>

              <div className="space-y-6" data-id="element-495">
                <h3 className="font-bold text-[#225274] flex items-center gap-2" data-id="element-496">
                  <Clock size={20} className="text-[#54c595]" data-id="element-497" />
                  Available Times
                </h3>
                <div className="grid grid-cols-3 gap-3" data-id="element-498">
                  {timeSlots.map(time => <button key={time} onClick={() => {
                  setSelectedTime(time);
                  nextStep();
                }} className={`py-3 rounded-xl text-sm font-bold border-2 transition-all ${selectedTime === time ? 'bg-[#54c595] border-[#54c595] text-white shadow-lg' : 'border-slate-100 text-slate-600 hover:border-[#54c595] hover:text-[#54c595]'}`} data-id="element-499">
                      {time}
                    </button>)}
                </div>
              </div>
            </div>
          </motion.div>;
      case 4:
        return <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="space-y-8" data-id="element-500">
            <button onClick={prevStep} className="flex items-center gap-2 text-sm font-bold text-[#4F709C] hover:text-[#225274] transition-colors" data-id="element-501">
              <ChevronLeft size={16} data-id="element-502" /> Back to Date & Time
            </button>

            <div className="max-w-2xl mx-auto bg-white p-8 md:p-12 rounded-[32px] border border-slate-100 shadow-xl" data-id="element-503">
              <h2 className="text-2xl font-bold text-[#225274] mb-8" data-id="element-504">
                Your Details
              </h2>
              <form className="space-y-6" onSubmit={e => {
              e.preventDefault();
              nextStep();
            }} data-id="element-505">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-506">
                  <div className="space-y-2" data-id="element-507">
                    <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-1" data-id="element-508">
                      Name *
                    </label>
                    <input required type="text" className="w-full bg-slate-50 border-none rounded-2xl py-4 px-6 focus:ring-2 focus:ring-[#54c595] transition-all" placeholder="Enter your full name" data-id="element-509" />
                  </div>
                  <div className="space-y-2" data-id="element-510">
                    <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-1" data-id="element-511">
                      Phone *
                    </label>
                    <input required type="tel" className="w-full bg-slate-50 border-none rounded-2xl py-4 px-6 focus:ring-2 focus:ring-[#54c595] transition-all" placeholder="(000) 000-0000" data-id="element-512" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-513">
                  <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-1" data-id="element-514">
                    Email *
                  </label>
                  <input required type="email" className="w-full bg-slate-50 border-none rounded-2xl py-4 px-6 focus:ring-2 focus:ring-[#54c595] transition-all" placeholder="your@email.com" data-id="element-515" />
                </div>
                <div className="space-y-2" data-id="element-516">
                  <label className="text-xs font-bold text-slate-400 uppercase tracking-widest ml-1" data-id="element-517">
                    Comments
                  </label>
                  <textarea rows={3} className="w-full bg-slate-50 border-none rounded-2xl py-4 px-6 focus:ring-2 focus:ring-[#54c595] transition-all resize-none" placeholder="Any special requests or information?" data-id="element-518" />
                </div>

                <div className="flex items-center gap-3 p-4 bg-[#cef4d2]/30 rounded-2xl border border-[#54c595]/20" data-id="element-519">
                  <input type="checkbox" id="messenger" className="w-5 h-5 rounded text-[#54c595] focus:ring-[#54c595]" data-id="element-520" />
                  <label htmlFor="messenger" className="text-sm font-medium text-[#225274] flex items-center gap-2" data-id="element-521">
                    <MessageSquare size={16} data-id="element-522" /> Send to Messenger
                  </label>
                </div>

                <div className="pt-4" data-id="element-523">
                  <button type="submit" className="w-full bg-gradient-to-r from-[#225274] via-[#4bafbc] to-[#54c595] text-white font-bold py-5 rounded-full shadow-lg shadow-teal-900/20 uppercase tracking-widest hover:brightness-110 transition-all" data-id="element-524">
                    Confirm Appointment
                  </button>
                </div>
              </form>
            </div>
          </motion.div>;
      case 5:
        return <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="text-center space-y-8 max-w-md mx-auto py-12" data-id="element-525">
            <div className="w-24 h-24 bg-[#54c595] rounded-full flex items-center justify-center mx-auto shadow-xl shadow-[#54c595]/20" data-id="element-526">
              <CheckCircle2 size={48} className="text-white" data-id="element-527" />
            </div>
            <div className="space-y-4" data-id="element-528">
              <h2 className="text-4xl font-bold text-[#225274]" data-id="element-529">
                Appointment Confirmed!
              </h2>
              <p className="text-slate-500" data-id="element-530">
                We've sent a confirmation email to your inbox.
              </p>
            </div>

            <div className="bg-slate-50 p-8 rounded-[32px] border border-slate-100 text-left space-y-4" data-id="element-531">
              <div className="flex justify-between items-center border-b border-slate-200 pb-4" data-id="element-532">
                <span className="text-sm font-bold text-slate-400 uppercase tracking-widest" data-id="element-533">
                  Doctor
                </span>
                <span className="font-bold text-[#225274]" data-id="element-534">
                  {selectedDoctor?.name}
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-slate-200 pb-4" data-id="element-535">
                <span className="text-sm font-bold text-slate-400 uppercase tracking-widest" data-id="element-536">
                  Service
                </span>
                <span className="font-bold text-[#225274]" data-id="element-537">
                  {selectedService?.name}
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-slate-200 pb-4" data-id="element-538">
                <span className="text-sm font-bold text-slate-400 uppercase tracking-widest" data-id="element-539">
                  Date
                </span>
                <span className="font-bold text-[#225274]" data-id="element-540">
                  Tuesday, June 23, 2026
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-541">
                <span className="text-sm font-bold text-slate-400 uppercase tracking-widest" data-id="element-542">
                  Time
                </span>
                <span className="font-bold text-[#225274]" data-id="element-543">
                  {selectedTime} -{' '}
                  {selectedTime.includes('30') ? parseInt(selectedTime) + 1 + ':00' : selectedTime.split(':')[0] + ':30'}{' '}
                  {selectedTime.split(' ')[1]}
                </span>
              </div>
            </div>

            <button onClick={() => window.location.href = '/'} className="w-full py-4 rounded-full border-2 border-[#225274] text-[#225274] font-bold uppercase tracking-widest hover:bg-[#225274] hover:text-white transition-all" data-id="element-544">
              Return Home
            </button>
          </motion.div>;
    }
  };
  return <div className="min-h-screen bg-[#F8FAFC]" data-id="element-545">
      <Header data-id="element-546" />

      <main className="pt-40 pb-24 px-4" data-id="element-547">
        <div className="max-w-5xl mx-auto" data-id="element-548">
          {/* Progress Bar */}
          {step < 5 && <div className="mb-12" data-id="element-549">
              <div className="flex justify-between items-center mb-4" data-id="element-550">
                {[1, 2, 3, 4].map(s => <div key={s} className="flex flex-col items-center gap-2" data-id="element-551">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all ${step >= s ? 'bg-[#225274] text-white shadow-lg' : 'bg-white text-slate-300 border-2 border-slate-100'}`} data-id="element-552">
                      {s}
                    </div>
                    <span className={`text-[10px] font-bold uppercase tracking-widest ${step >= s ? 'text-[#225274]' : 'text-slate-300'}`} data-id="element-553">
                      {s === 1 ? 'Doctor' : s === 2 ? 'Service' : s === 3 ? 'Schedule' : 'Details'}
                    </span>
                  </div>)}
              </div>
              <div className="h-1 bg-slate-100 rounded-full overflow-hidden" data-id="element-554">
                <motion.div className="h-full bg-[#54c595]" initial={{
              width: '25%'
            }} animate={{
              width: `${step / 4 * 100}%`
            }} data-id="element-555" />
              </div>
            </div>}

          <div className="min-h-[600px]" data-id="element-556">
            <AnimatePresence mode="wait" data-id="element-557">{renderStep()}</AnimatePresence>
          </div>

          {/* Policies */}
          {step < 5 && <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="mt-16 grid md:grid-cols-2 gap-8" data-id="element-558">
              <div className="bg-white p-8 rounded-3xl border border-slate-100 shadow-sm space-y-4" data-id="element-559">
                <div className="flex items-center gap-3 text-[#225274]" data-id="element-560">
                  <ShieldCheck size={24} className="text-[#54c595]" data-id="element-561" />
                  <h4 className="font-bold uppercase tracking-widest text-sm" data-id="element-562">
                    Booking Policy
                  </h4>
                </div>
                <p className="text-sm text-slate-500 leading-relaxed" data-id="element-563">
                  We require a 24-hour courtesy cancellation notice to avoid a{' '}
                  <span className="font-bold text-[#225274]" data-id="element-564">
                    $25 cancellation fee
                  </span>
                  .
                </p>
              </div>
              <div className="bg-white p-8 rounded-3xl border border-slate-100 shadow-sm space-y-4" data-id="element-565">
                <div className="flex items-center gap-3 text-[#225274]" data-id="element-566">
                  <Clock size={24} className="text-[#54c595]" data-id="element-567" />
                  <h4 className="font-bold uppercase tracking-widest text-sm" data-id="element-568">
                    Cancellation Policy
                  </h4>
                </div>
                <p className="text-sm text-slate-500 leading-relaxed" data-id="element-569">
                  You can cancel or reschedule anytime before the appointment
                  time.
                </p>
              </div>
              <div className="md:col-span-2 text-center text-[10px] text-slate-400 max-w-2xl mx-auto" data-id="element-570">
                When booking with Colesville Dental center, you may receive
                appointment-specific communication from Setmore. This includes
                confirmations, receipts and reminders via email and SMS.
              </div>
            </motion.div>}
        </div>
      </main>

      <Footer data-id="element-571" />
    </div>;
}